LabelList = require 'app/scripts/models/collections/label-list'
LabelsHelper = require 'app/scripts/models/internal/labels-helper'
LocalStorageModel = require 'app/scripts/view-models/internal/local-storage-model'
{ mixin } = require 'app/scripts/lib/mixin_DO_NOT_USE'

module.exports = mixin LabelsHelper, class CardComposer extends LocalStorageModel
  typeName: 'CardComposer'

  constructor: (attrs, { @board }) ->
    super
    @waitForId @board, (idBoard) =>
      @set(id: "boardCardComposerSettings-#{ idBoard }")
      @fetch()

  @lazy
    labelList: ->
      new LabelList()
      .syncModel(@, 'idLabels')
      .syncCache @modelCache, [], (label) =>
        label.id in (@get('idLabels') ? [])

  syncedKeys: ['title']

  default: ->
    list: null
    index: null
    idMembers: []
    idLabels: []
    pos: 'bottom'
    title: ""
    vis: false

  clear: ->
    @save(@default())

  clearItems: ->
    @labelList.reset()
    @save({
      idMembers: []
      idLabels: []
      title: ""
    })
    return

  moveToNext: ->
    @save
      index: (@get('index') ? 0) + 1
    return

  getBoard: ->
    @board

  getList: -> @get 'list'

  editable: -> @getBoard().editable()

  addMember: (idMember) -> @addToSet('idMembers', idMember)
  removeMember: (idMember) -> @pull('idMembers', idMember)

  # For the LabelsHelper mixin
  labelCreateUrl: -> "/1/board/#{@getBoard().id}/labels/"

  # For now, no suggestions on card composer
  isValidSuggestion: -> false